import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "Career Trajectory",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Career Trajectory</h2>
                                    <p>Discovering Your Purpose and Charting Your Future</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/career.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>Are you seeking clarity and purpose in your career? This course, "Career Trajectory," provides a structured framework to discover your core values, passions, and strengths, empowering you to design a personalised career path that aligns with your long-term aspirations.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why I Created This Course</h5>
                                                    <p>Throughout my career, I have observed countless professionals drifting, lacking a clear sense of direction. This course is born from a desire to empower individuals to take control of their career narrative, to move beyond simply "having a job" and towards building a fulfilling, purposeful career.</p>

                                                    <h5 className="title mt-3">Course Curriculum</h5>
                                                    <ul className="liststyle">
                                                        <li>Module 1: Career Discovery: Uncovering Your Core Values and Passions: Identifying your intrinsic motivators and aligning them with career choices.</li>
                                                        <li>Module 2: Strength Assessment and Articulation: Recognising and articulating your unique strengths and talents.</li>
                                                        <li>Module 3: Strategic Career Planning and Goal Setting: Developing a personalised roadmap for achieving your career aspirations.</li>
                                                        <li>Module 4: Building a Powerful Personal Brand and Network: Crafting a compelling professional identity and leveraging networking strategies.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this course, you will learn how to:</h5>
                                                    <ul className="liststyle">
                                                        <li>Identify your core values and passions to drive career decisions.</li>
                                                        <li>Articulate your unique strengths and talents.</li>
                                                        <li>Develop a strategic career plan and set achievable goals.</li>
                                                        <li>Build a powerful personal brand that resonates with your desired career path.</li>
                                                        <li>Leverage effective networking strategies to expand your professional opportunities.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this course, you will leave with:</p>
                                                    <ul className="liststyle">
                                                        <li>A personalised career trajectory plan.</li>
                                                        <li>A clear understanding of your core values and strengths.</li>
                                                        <li>A compelling personal brand statement and networking strategy.</li>
                                                        <li>The confidence and clarity to pursue a purposeful career.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the course structured?</h5>
                                                    <p>This comprehensive ten-weeks Program features live interactive workshops, personalised exercises, and expert guidance. You will also gain access to a dedicated online community and exclusive resources.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this course suitable for professionals at any stage of their career?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, this course is designed for anyone seeking greater clarity and purpose in their career journey, regardless of experience level.</p>

                                                        <li>Will this course help me if I am considering a career change?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. The career discovery process is particularly valuable for those seeking to transition into new roles or industries.</p>

                                                        <li>Are there practical networking strategies taught in this course?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, we cover a range of effective networking techniques, both online and offline.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £499</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("Career Trajectory", "https://mainstack.store/coachdoi/ca1cinvjPoVk")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;